import React,{ Component} from 'react';
import {getPartners, getAllPartners} from '../../api/partnerApi';
import {CustomMenu} from './Menu';
import queryString from 'query-string';
import axios from 'axios';
import history from '../../history';
import ErrorMessage from '../ErrorMessage';
import {Link, NavLink} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Tabs, Tab} from 'react-bootstrap';
import {Modal as ModalExample, Badge} from '../shared';
import swal from 'sweetalert';
import {Menu, Segment, Pagination, Input, Accordion, Dropdown, Button} from 'semantic-ui-react';
import FilterForm from './FilterForm';
import moment from 'moment';
import {getSummary, createServiceTransaction} from '../../api/serviceTransactionApi';
import {formatMoneyLegacy} from '../../utils/currency';
import {getGroupTours, showGroupTour} from '../../api/groupToursApi';
import {getSharedRentals, showSharedRental} from '../../api/sharedRentalsApi';
import {getPartnerServices} from '../../api/partnerServiceApi';
import VendorTripsPanel from './VendorTripsPanel';
import { vendorShareAmount, tripRemainingAmount } from '../../utils/vendorPayoutStatus';

/** Only trips actually assigned to this vendor (vendor_id set). */
function filterAssignedToVendor(items, vendorId) {
	return (items || []).filter((t) => t.vendor_id != null && String(t.vendor_id) === String(vendorId));
}

function fetchVendorAssignments(vendorId) {
	const params = { admin_list: true, vendor_id: vendorId, assigned_only: true, per_page: 100 };
	return Promise.all([
		getGroupTours(params).then((r) => filterAssignedToVendor(r.data.group_tours, vendorId)).catch(() => []),
		getSharedRentals(params).then((r) => filterAssignedToVendor(r.data.shared_rentals, vendorId)).catch(() => []),
		getPartnerServices({ q: { vendor_id_eq: vendorId }, per_page: 100 })
			.then((r) => filterAssignedToVendor(r.data?.vendor_services || (Array.isArray(r.data) ? r.data : []), vendorId))
			.catch(() => [])
	]).then(([group_tours, shared_rentals, vendor_services]) => ({ group_tours, shared_rentals, vendor_services }));
}


const PartnerView = ({partner={}}) => {
	if(!partner){
		return <div></div>
	}
	return <div>
		{partner.full_name} ({partner.company_name})
		<div>{partner.email}</div>
	</div>
};

/** Normalize summary to by_currency shape (backward compat when API returns flat credit/debit/due). */
function getByCurrency(summary) {
	if (summary.by_currency && Object.keys(summary.by_currency).length > 0) {
		return summary.by_currency;
	}
	return { NPR: { credit: summary.credit, debit: summary.debit, due: summary.due } };
}

function hasAnyDue(summary) {
	const byCurrency = getByCurrency(summary);
	return Object.values(byCurrency).some(c => (Number(c.due) || 0) > 0);
}

function getUnpaidByCurrency(summary) {
	if (summary.unpaid_by_currency && Object.keys(summary.unpaid_by_currency).length > 0) {
		return summary.unpaid_by_currency;
	}
	const byCurrency = getByCurrency(summary);
	return Object.fromEntries(Object.entries(byCurrency).map(([cc, row]) => [cc, { due: row.due, unpaid_count: 0, paid_count: 0 }]));
}

function bulkDueForCurrency(summary, currencyCode) {
	const unpaid = getUnpaidByCurrency(summary);
	const cc = currencyCode || 'NPR';
	if (unpaid[cc]?.due != null) return Math.max(0, Number(unpaid[cc].due) || 0);
	const row = getByCurrency(summary)[cc];
	return Math.max(0, Number(row?.due) || 0);
}

function hasBulkDue(summary) {
	const unpaid = getUnpaidByCurrency(summary);
	if (Object.keys(unpaid).length > 0) {
		return Object.values(unpaid).some(row => (Number(row.due) || 0) > 0);
	}
	return hasAnyDue(summary);
}

const PAYMENT_METHODS = [
	{ value: 'offline_bank', label: 'Bank transfer' },
	{ value: 'offline_cash', label: 'Cash' },
	{ value: 'offline_cheque', label: 'Cheque' }
];

class SummaryList extends Component{
    constructor(props){
        super(props);
        this.state={
            partners: [],
            summaries: [],
            recordPaymentOpen: false,
			recordPaymentForm: { vendor_id: '', vendor_name: '', khalti_identifier: '', amount: '', due: 0, credit: 0, debit: 0, payment_mode: 'offline_bank', receipt_no: '', remarks: '' },
            recording: false,
            expandedVendorId: null,
            assignments: { group_tours: [], shared_rentals: [], vendor_services: [] },
            loadingAssignments: false,
            recordForTrip: null,
            payingTripId: null,
            membersModal: null,
            loadingMembers: false
        }
    }

    // changeCurrentPage = (e, {activePage}) => {
	// 	var searchQuery = `?page=${activePage}`;
	// 	this.setState({currentPage: activePage});
	// 	this.getSummary({page: activePage});
	// 	history.push({
	// 		pathname: window.location.pathname,
	// 		search: searchQuery
	// 	});
	// };


    componentDidMount(){
        this.fetchPartners();
    }

    fetchPartners(){
        getAllPartners({ per_page: 500 })
        .then((response) => {
            const list = (response.data && (Array.isArray(response.data) ? response.data : response.data.partners)) || [];
            this.setState({ partners: list });
        })
        .catch((error) => {
            console.log(error);
        });

        this.refreshPayoutSummaries();
    }

    refreshPayoutSummaries = () => {
		return getSummary(queryString.parse(this.props.location.search))
			.then((response) => {
				const data = response.data;
				const list = (data && data.summaries) || (Array.isArray(data) ? data : []) || [];
				this.setState({ summaries: list });
				return list;
			})
			.catch((error) => {
				console.log('Summary fetch error', error);
				return [];
			});
    };

    refreshExpandedVendorTrips = (vendorId = this.state.expandedVendorId) => {
		if (!vendorId) return Promise.resolve();
		this.setState({ loadingAssignments: true });
		return fetchVendorAssignments(vendorId)
			.then((assignments) => {
				this.setState({ assignments, loadingAssignments: false });
				return assignments;
			})
			.catch(() => {
				this.setState({ loadingAssignments: false });
				return null;
			});
    };

    refreshPayoutView = (vendorId = this.state.expandedVendorId) => {
		return Promise.all([
			this.refreshPayoutSummaries(),
			this.refreshExpandedVendorTrips(vendorId)
		]);
    };

    onFilter = (values) => {
		this.setState({
			summaries: values.summaries
		});
    };

    openRecordPayment = (summary, tripRow = null) => {
		const trip = tripRow?.trip || (tripRow?.assignment_type ? tripRow : null);
		const item = tripRow?.item;
		const p = this.state.partners.find(pa => pa.id == summary.vendor_id);
		const partnerName = summary.vendor_name || (p ? (p.company_name || `${p.first_name || ''} ${p.last_name || ''}`).trim() : null) || `Vendor #${summary.vendor_id}`;
		const khaltiId = (p && p.khalti_identifier) ? String(p.khalti_identifier).trim() : '';
		const byCurrency = summary.by_currency && Object.keys(summary.by_currency).length > 0
			? summary.by_currency
			: { NPR: { credit: summary.credit, debit: summary.debit, due: summary.due } };
		const unpaidByCurrency = getUnpaidByCurrency(summary);
		const currenciesWithUnpaid = Object.keys(unpaidByCurrency).filter(cc => (Number(unpaidByCurrency[cc]?.due) || 0) > 0).sort();
		const currenciesWithDue = Object.keys(byCurrency).filter(cc => (Number(byCurrency[cc].due) || 0) > 0).sort();
		let currencyCode = currenciesWithUnpaid[0] || currenciesWithDue[0] || Object.keys(byCurrency)[0] || 'NPR';
		const itemCurrency = (item?.currency_code || '').trim().toUpperCase();
		if (itemCurrency && (byCurrency[itemCurrency] || unpaidByCurrency[itemCurrency])) currencyCode = itemCurrency;
		const row = byCurrency[currencyCode] || {};
		let due = Math.max(0, Number(row.due) || 0);
		let amount = due > 0 ? String(due) : '';
		if (trip && item) {
			const share = vendorShareAmount(item).value ?? trip.vendor_amount ?? 0;
			const paid = Number(item.vendor_paid_total ?? 0);
			const tripRemaining = Math.max(0, share - paid);
			const decimals = currencyCode === 'USD' ? 2 : 0;
			due = tripRemaining;
			amount = tripRemaining > 0 ? String(tripRemaining.toFixed(decimals)) : (share > 0 ? String(Number(share).toFixed(decimals)) : '');
		} else if (trip && trip.vendor_amount != null) {
			amount = String(Number(trip.vendor_amount).toFixed(currencyCode === 'USD' ? 2 : 0));
		} else {
			const unpaidDue = bulkDueForCurrency(summary, currencyCode);
			due = unpaidDue;
			const decimals = currencyCode === 'USD' ? 2 : 0;
			amount = unpaidDue > 0 ? String(unpaidDue.toFixed(decimals)) : '';
		}
		this.setState({
			recordPaymentOpen: true,
			recordForTrip: trip,
			recordPaymentForm: {
				vendor_id: summary.vendor_id,
				vendor_name: partnerName,
				khalti_identifier: khaltiId,
				by_currency: byCurrency,
				unpaid_by_currency: unpaidByCurrency,
				currency_code: currencyCode,
				amount,
				due,
				credit: row.credit,
				debit: row.debit,
				payment_mode: 'offline_bank',
				receipt_no: '',
				remarks: ''
			}
		});
    };

    toggleVendorTrips = (summary) => {
		const id = summary.vendor_id;
		if (this.state.expandedVendorId === id) {
			this.setState({ expandedVendorId: null, assignments: { group_tours: [], shared_rentals: [], vendor_services: [] } });
			return;
		}
		this.setState({ expandedVendorId: id, loadingAssignments: true, assignments: { group_tours: [], shared_rentals: [], vendor_services: [] } });
		fetchVendorAssignments(id)
			.then((assignments) => this.setState({ assignments, loadingAssignments: false }))
			.catch(() => this.setState({ loadingAssignments: false }));
	};

    fetchAssignmentsForPartner = (partnerId) => {
		if (!partnerId) return;
		this.setState({ loadingAssignments: true });
		fetchVendorAssignments(partnerId)
			.then((assignments) => this.setState({ assignments, loadingAssignments: false }))
			.catch(() => this.setState({ loadingAssignments: false }));
	};

    closeRecordPayment = () => {
		this.setState({ recordPaymentOpen: false, recordForTrip: null });
    };

    handleViewMembers = (row) => {
		const title = `${row.type}: ${row.name}`;
		this.setState({ membersModal: { title, members: [] }, loadingMembers: true });
		const fetchApi = row.type === 'Group Tour' ? showGroupTour(row.trip.assignment_idx) : showSharedRental(row.trip.assignment_idx);
		fetchApi
			.then((res) => {
				const data = res.data || {};
				const members = data.members || [];
				this.setState({ membersModal: { title, members }, loadingMembers: false });
			})
			.catch(() => {
				swal('Error', 'Could not load members.', 'error');
				this.setState({ membersModal: null, loadingMembers: false });
			});
    };

    closeMembersModal = () => this.setState({ membersModal: null });

    recordTripPayment = (summary, row, rowKey) => {
		const item = row.item;
		const trip = row.trip;
		const remaining = tripRemainingAmount(item);
		const cc = (item?.currency_code || 'NPR').toString().toUpperCase();
		if (!summary.vendor_id || !trip?.assignment_type || !trip?.assignment_idx) {
			swal('Error', 'Missing trip or vendor information.', 'error');
			return;
		}
		if (remaining <= 0) {
			swal('Nothing to pay', 'This trip is already paid in full.', 'info');
			return;
		}
		const amountLabel = formatMoneyLegacy(remaining, cc);
		swal({
			title: 'Record payment?',
			text: `Pay ${amountLabel} to ${summary.vendor_name || 'this vendor'} for "${row.name}"? This confirms the trip and records payment in one step.`,
			icon: 'warning',
			buttons: ['Cancel', 'Record payment'],
		}).then((confirmed) => {
			if (!confirmed) return;
			this.setState({ payingTripId: rowKey, recording: true });
			createServiceTransaction({
				vendor_id: summary.vendor_id,
				direction: 'debit',
				amount: remaining,
				currency_code: cc,
				closing_balance: 0,
				payment_mode: 'offline_bank',
				assignment_type: trip.assignment_type,
				assignment_idx: trip.assignment_idx,
			})
				.then(() => this.refreshPayoutView(summary.vendor_id))
				.then(() => swal('Paid', 'Payment recorded. The vendor portal will show Paid for this trip.', 'success'))
				.catch((e) => swal('Error', (e.response?.data?.errors || [])?.join(' ') || 'Failed to record payment', 'error'))
				.finally(() => this.setState({ payingTripId: null, recording: false }));
		});
    };

    onRecordPaymentCurrencyChange = (currencyCode) => {
		const { recordPaymentForm, recordForTrip } = this.state;
		const byCurrency = recordPaymentForm.by_currency || {};
		const unpaidByCurrency = recordPaymentForm.unpaid_by_currency || {};
		const row = byCurrency[currencyCode] || {};
		const isPerTrip = !!(recordForTrip && recordForTrip.assignment_type && recordForTrip.assignment_idx);
		const due = isPerTrip
			? Math.max(0, Number(recordPaymentForm.due) || 0)
			: Math.max(0, Number(unpaidByCurrency[currencyCode]?.due ?? row.due) || 0);
		const decimals = currencyCode === 'USD' ? 2 : 0;
		this.setState({
			recordPaymentForm: {
				...recordPaymentForm,
				currency_code: currencyCode,
				credit: row.credit,
				debit: row.debit,
				due,
				amount: due > 0 ? String(due.toFixed(decimals)) : ''
			}
		});
    };

    recordPaymentSubmit = () => {
		const { recordPaymentForm, recordForTrip } = this.state;
		const amount = Number(recordPaymentForm.amount);
		const due = Number(recordPaymentForm.due) || 0;
		const currencyCode = (recordPaymentForm.currency_code || '').trim().toUpperCase() || 'NPR';
		if (!recordPaymentForm.vendor_id || !amount || amount <= 0) {
			swal('Invalid', 'Amount is required and must be greater than 0.', 'info');
			return;
		}
		const isPerTrip = !!(recordForTrip && recordForTrip.assignment_type && recordForTrip.assignment_idx);
		if (!isPerTrip && due <= 0) {
			swal('Nothing to pay', 'All credited trips are already paid. Use Pay trip if one assignment still shows unpaid.', 'info');
			return;
		}
		if (isPerTrip && due <= 0) {
			swal('Nothing to pay', 'This trip is already paid in full.', 'info');
			return;
		}
		if (amount > due) {
			swal('Invalid', `Amount cannot exceed ${isPerTrip ? 'this trip\'s remaining balance' : 'unpaid trip balance (already-paid trips excluded)'} (${currencyCode} ${due.toFixed(currencyCode === 'USD' ? 2 : 0)}).`, 'info');
			return;
		}
		this.setState({ recording: true });
		const payload = {
			vendor_id: recordPaymentForm.vendor_id,
			direction: 'debit',
			amount,
			currency_code: currencyCode,
			closing_balance: 0,
			payment_mode: recordPaymentForm.payment_mode,
			receipt_no: recordPaymentForm.receipt_no || undefined,
			remarks: recordPaymentForm.remarks || undefined
		};
		if (recordForTrip && recordForTrip.assignment_type && recordForTrip.assignment_idx) {
			payload.assignment_type = recordForTrip.assignment_type;
			payload.assignment_idx = recordForTrip.assignment_idx;
		}
		createServiceTransaction(payload)
			.then(() => {
				const vendorId = recordPaymentForm.vendor_id || this.state.expandedVendorId;
				this.closeRecordPayment();
				return this.refreshPayoutView(vendorId).then(() => {
					swal('Recorded', 'Payment recorded. Vendor balance has been updated.', 'success');
				});
			})
			.catch((e) => swal('Error', (e.response?.data?.errors || [])?.join(' ') || 'Failed to record payment', 'error'))
			.finally(() => this.setState({ recording: false }));
    };
    
    render(){
        const {partners, summaries, pagination} = this.state;
        
        const filterFields = [
			{
				name: 'created_at_gteq',
				label: 'From Date',
				type: 'date'
			},
			{
				name: 'created_at_lteq',
				label: 'To Date',
				type: 'date'
			},

			{
				name: 'amount_eq',
				label: 'amount',
				type: 'text'
			},

			// {
			// 	name: 'partner_first_name_or_partner_last_name_cont',
			// 	label: 'Partner Name',
			// 	type: 'text'
			// },

			{
				label: 'Partner Name',
				type: 'select',
				//name: 'vendor_id_eq',
				name: 'vendor_id_eq',
				options: partners.map(function(partner) {
					// key: partner.id
					// value: partner.id
					var pName = partner.first_name + " " +  partner.last_name;
					return{
						key: partner.id,
						value: partner.id,
						text: pName
					};
					 
					
				})
			},

			{
				name: 'closing_balance_eq',
				label: 'Total Transaction',
				type: 'text'
			},

			{
				name: 'remarks_cont',
				label: 'Remarks',
				type: 'text'
			}
		];
        const partnerDisplay = (summary) => {
			const p = partners.find(pa => pa.id == summary.vendor_id);
			const name = summary.vendor_name || (p ? (p.company_name || `${p.first_name || ''} ${p.last_name || ''}`).trim() : null) || `Vendor #${summary.vendor_id}`;
			const email = summary.vendor_email || p?.email;
			return (
				<div>
					<div>{name}</div>
					{email && <div className="small text-muted">{email}</div>}
				</div>
			);
		};

        return(
            <React.Fragment>
				<div className='ui container admin-summaries-page'>
					<div className='' id='search-form'>
						<div className='row'>
							<div className='col-12 col-md-6 col-lg-4'>
								<h3 className='title'>Vendor payouts</h3>
								<p className='text-muted small mb-0'>Click <strong>View trips</strong> → pick a month → <strong>Record payment</strong> (one step per trip). Use bulk payment on the vendor row to settle several at once.</p>
							</div>
						</div>

						{summaries.length > 0 && (
							<CustomMenu
								submitUrl='service_transactions/summary'
								filterFields={filterFields}
								onFilter={(values) => this.onFilter(values)}
								items={[
									{
										label: 'Transaction Type',
										type: 'dropdown',
										name: 'direction_eq',
										objects: [
											{ label: 'debit', value: 'debit' },
											{ label: 'credit', value: 'credit' }
										]
									}
								]}
							/>
						)}

						{summaries.length === 0 && !(partners.length > 0) && (
							<p className='text-muted mt-2'>Loading…</p>
						)}
						{summaries.length === 0 && partners.length > 0 && (
							<Segment>
								<p className='text-muted mb-0'>No vendor summaries yet. Assign vendors to bookings/tours to see balances here.</p>
								<Link to='/admin/service_transactions' className='btn btn-outline-primary btn-sm mt-2'>Open vendor ledger</Link>
							</Segment>
						)}

						{summaries.length > 0 && (
							<Segment>
								<p className='text-muted small mb-2'>Click <strong>View trips</strong> → pick a month → <strong>Record payment</strong> per trip (confirms + pays in one click). Or use <strong>Record payment (bulk)</strong> on the vendor row.</p>
								<p className='text-muted small mb-2'>Each row is a separate vendor account. Renaming a company does not merge past payouts — check the email if two rows look like the same person.</p>

								{/* Mobile: card list */}
								<div className='admin-summary-list-mobile d-block d-md-none'>
									{summaries.map((summary, index) => {
										const byCurrency = getByCurrency(summary);
										const duePositive = hasBulkDue(summary);
										return (
											<div key={summary.vendor_id || index} className='admin-summary-card mb-3 p-3 border rounded'>
												<div className='d-flex justify-content-between align-items-start flex-wrap gap-2'>
													<div className='flex-grow-1 min-w-0'>
														<div className='font-weight-bold text-dark'>{index + 1}. {partnerDisplay(summary)}</div>
														<div className='mt-2 small'>
															{Object.keys(byCurrency).sort().map(cc => {
																const row = byCurrency[cc];
																const dueVal = Math.max(0, Number(row.due) || 0);
																const overpaid = (Number(row.due) || 0) < 0 ? Math.abs(Number(row.due)) : 0;
																const label = cc === 'NPR' ? 'NPR (Rs)' : cc;
																return (
																	<div key={cc} className='d-flex flex-wrap mb-1'>
																		<span className='mr-2 font-weight-medium'>{label}:</span>
																		<span className='mr-3'>Earned: {formatMoneyLegacy(row.credit, cc)}</span>
																		<span className='mr-3'>Paid: {formatMoneyLegacy(row.debit, cc)}</span>
																		<span className={dueVal > 0 ? 'text-primary font-weight-bold' : ''}>Due: {formatMoneyLegacy(row.due, cc)}</span>
																		{overpaid > 0 && <span className='text-warning small'>Overpaid: {formatMoneyLegacy(overpaid, cc)}</span>}
																	</div>
																);
															})}
														</div>
														{this.state.expandedVendorId === summary.vendor_id && (
															<div className='mt-3'>
																{this.state.loadingAssignments ? (
																	<div className='text-muted small'>Loading trips…</div>
																) : (
																	<VendorTripsPanel
																		assignments={this.state.assignments}
																		loading={this.state.loadingAssignments}
																		onViewMembers={this.handleViewMembers}
																		onRecordPayment={(row, rowKey) => this.recordTripPayment(summary, row, rowKey)}
																		payingTripId={this.state.payingTripId}
																	/>
																)}
															</div>
														)}
													</div>
													<div className='d-flex flex-wrap'>
														<button type='button' className='btn btn-sm btn-outline-secondary mr-1 mb-1' onClick={() => this.toggleVendorTrips(summary)} disabled={!!this.state.loadingAssignments}>
															{this.state.expandedVendorId === summary.vendor_id ? 'Hide trips' : 'View trips'}
														</button>
														<Link to={`/admin/service_transactions?vendor_id=${summary.vendor_id}`} className='btn btn-sm btn-outline-info mr-1 mb-1'>View ledger</Link>
														<button type='button' className='btn btn-sm btn-outline-primary mb-1' onClick={() => this.openRecordPayment(summary)} disabled={!!this.state.recording || !duePositive}>Record payment (bulk)</button>
													</div>
												</div>
											</div>
										);
									})}
								</div>

								{/* Desktop: table */}
								<div className='d-none d-md-block table-responsive'>
									<table className='table table-striped table-bordered'>
										<thead>
											<tr>
												<th>S. No.</th>
												<th>Vendor</th>
												<th>Earned</th>
												<th>Paid</th>
												<th>Due</th>
												<th>Actions</th>
											</tr>
										</thead>
										<tbody>
											{summaries.map((summary, index) => {
												const byCurrency = getByCurrency(summary);
												const duePositive = hasBulkDue(summary);
												return (
												<React.Fragment key={summary.vendor_id || index}>
													<tr>
														<td>{index + 1}</td>
														<td>{partnerDisplay(summary)}</td>
														<td>
															{Object.keys(byCurrency).sort().map(cc => (
																<div key={cc} className='small'>{cc}: {formatMoneyLegacy(byCurrency[cc].credit, cc)}</div>
															))}
														</td>
														<td>
															{Object.keys(byCurrency).sort().map(cc => (
																<div key={cc} className='small'>{cc}: {formatMoneyLegacy(byCurrency[cc].debit, cc)}</div>
															))}
														</td>
														<td>
															{Object.keys(byCurrency).sort().map(cc => {
																const row = byCurrency[cc];
																const dueVal = Math.max(0, Number(row.due) || 0);
																const overpaid = (Number(row.due) || 0) < 0 ? Math.abs(Number(row.due)) : 0;
																return (
																	<div key={cc} className='small'>
																		{cc}: {formatMoneyLegacy(row.due, cc)}
																		{overpaid > 0 && <small className='d-block text-warning'>Overpaid: {formatMoneyLegacy(overpaid, cc)}</small>}
																	</div>
																);
															})}
														</td>
														<td>
															<button type='button' className='btn btn-sm btn-outline-secondary mr-1' onClick={() => this.toggleVendorTrips(summary)} disabled={!!this.state.loadingAssignments}>
																{this.state.expandedVendorId === summary.vendor_id ? 'Hide trips' : 'View trips'}
															</button>
															<Link to={`/admin/service_transactions?vendor_id=${summary.vendor_id}`} className='btn btn-sm btn-outline-info mr-1'>View ledger</Link>
															<button type='button' className='btn btn-sm btn-outline-primary' onClick={() => this.openRecordPayment(summary)} disabled={!!this.state.recording || !duePositive}>Record payment (bulk)</button>
														</td>
													</tr>
													{this.state.expandedVendorId === summary.vendor_id && (
														<tr>
															<td colSpan={6} className='p-0 bg-light'>
																{this.state.loadingAssignments ? (
																	<div className='p-3 text-muted'>Loading trips…</div>
																) : (
																	<VendorTripsPanel
																		assignments={this.state.assignments}
																		loading={this.state.loadingAssignments}
																		onViewMembers={this.handleViewMembers}
																		onRecordPayment={(row, rowKey) => this.recordTripPayment(summary, row, rowKey)}
																		payingTripId={this.state.payingTripId}
																	/>
																)}
															</td>
														</tr>
													)}
												</React.Fragment>
											);
											})}
										</tbody>
									</table>
								</div>
							</Segment>
						)}
					</div>
				</div>

				{this.state.recordPaymentOpen && (
					<div className='modal fade show d-block modal-record-payment-bulk' style={{ background: 'rgba(0,0,0,0.5)' }} tabIndex={-1}>
						<div className='modal-dialog modal-dialog-centered modal-lg'>
							<div className='modal-content modal-record-payment-bulk-content'>
								<div className='modal-header flex-shrink-0'>
									<h5 className='modal-title'>{this.state.recordForTrip ? 'Record payment to vendor (this trip)' : 'Record payment to vendor (bulk)'}</h5>
									<button type='button' className='close' onClick={this.closeRecordPayment}><span>&times;</span></button>
								</div>
								<div className='modal-body px-3 px-md-4 overflow-auto'>
									<div className='form-group'>
										<label className='text-wrap'>Vendor</label>
										<p className='form-control-plaintext font-weight-bold mb-0'>{this.state.recordPaymentForm.vendor_name}</p>
									</div>
									{this.state.recordPaymentForm.khalti_identifier && (
										<div className='form-group p-2 bg-light rounded'>
											<label className='small text-muted mb-0 text-wrap'>Khalti number (for offline transfer)</label>
											<p className='form-control-plaintext font-weight-bold mb-0'>{this.state.recordPaymentForm.khalti_identifier}</p>
										</div>
									)}
									{this.state.recordPaymentForm.by_currency && Object.keys(this.state.recordPaymentForm.by_currency).length > 1 && (
										<div className='form-group'>
											<label className='text-wrap'>Pay in currency *</label>
											<select className='form-control' value={this.state.recordPaymentForm.currency_code || 'NPR'} onChange={(e) => this.onRecordPaymentCurrencyChange(e.target.value)}>
												{Object.keys(this.state.recordPaymentForm.by_currency).sort().map(cc => (
													<option key={cc} value={cc}>{cc === 'USD' ? 'USD' : cc === 'NPR' ? 'NPR (Rs)' : cc}</option>
												))}
											</select>
										</div>
									)}
									<div className='form-group p-2 bg-light rounded mb-3'>
										{!this.state.recordForTrip && this.state.recordPaymentForm.unpaid_by_currency && (
											<div className='mb-2'>
												<small className='text-muted d-block text-wrap mb-1'>Bulk payment covers unpaid trips only — already-paid trips are excluded.</small>
												{Object.keys(this.state.recordPaymentForm.unpaid_by_currency).sort().map(cc => {
													const unpaid = this.state.recordPaymentForm.unpaid_by_currency[cc];
													if (!unpaid) return null;
													const isSelected = (this.state.recordPaymentForm.currency_code || 'NPR') === cc;
													if (!isSelected && (Number(unpaid.due) || 0) <= 0) return null;
													return (
														<div key={`unpaid-${cc}`} className={isSelected ? 'mb-2 p-2 border border-success rounded' : 'mb-2 small'}>
															<strong>{cc === 'USD' ? 'USD' : cc === 'NPR' ? 'NPR (Rs)' : cc}</strong>
															<span className='ml-2 text-success font-weight-bold'>Unpaid trips: {formatMoneyLegacy(unpaid.due, cc)}</span>
															{(Number(unpaid.unpaid_count) || 0) > 0 && (
																<span className='ml-2 small text-muted'>({unpaid.unpaid_count} unpaid{(Number(unpaid.paid_count) || 0) > 0 ? `, ${unpaid.paid_count} already paid` : ''})</span>
															)}
														</div>
													);
												})}
											</div>
										)}
										{this.state.recordPaymentForm.by_currency && Object.keys(this.state.recordPaymentForm.by_currency).length > 0 && (
											<>
												<small className='text-muted d-block text-wrap mb-2'>Account totals (all trips)</small>
												{Object.keys(this.state.recordPaymentForm.by_currency).sort().map(cc => {
													const row = this.state.recordPaymentForm.by_currency[cc];
													const isSelected = (this.state.recordPaymentForm.currency_code || 'NPR') === cc;
													return (
														<div key={cc} className={isSelected ? 'mb-2 p-2 border border-primary rounded' : 'mb-2 small'}>
															<strong>{cc === 'USD' ? 'USD' : cc === 'NPR' ? 'NPR (Rs)' : cc}</strong>
															<span className='ml-2'>Earned: {formatMoneyLegacy(row.credit, cc)}</span>
															<span className='ml-2'>Paid: {formatMoneyLegacy(row.debit, cc)}</span>
															<span className='ml-2'>Account due: {formatMoneyLegacy(row.due, cc)}</span>
														</div>
													);
												})}
											</>
										)}
										{(!this.state.recordPaymentForm.by_currency || Object.keys(this.state.recordPaymentForm.by_currency).length === 0) && (
											<>
												<small className='text-muted d-block text-wrap'>Earned</small>
												<strong>{formatMoneyLegacy(this.state.recordPaymentForm.credit, this.state.recordPaymentForm.currency_code || 'NPR')}</strong>
												<small className='text-muted d-block mt-1 text-wrap'>Paid so far</small>
												<strong>{formatMoneyLegacy(this.state.recordPaymentForm.debit, this.state.recordPaymentForm.currency_code || 'NPR')}</strong>
												<small className='text-muted d-block mt-1 text-wrap'>Balance due — pay this or any partial amount</small>
												<strong className='text-primary'>{formatMoneyLegacy(this.state.recordPaymentForm.due, this.state.recordPaymentForm.currency_code || 'NPR')}</strong>
											</>
										)}
									</div>
									<div className='form-group'>
										<label className='text-wrap'>Amount to record now ({this.state.recordPaymentForm.currency_code || 'NPR'}) *</label>
										<input type='number' min={0.01} step={this.state.recordPaymentForm.currency_code === 'USD' ? 0.01 : 1} className='form-control' value={this.state.recordPaymentForm.amount} onChange={(e) => this.setState({ recordPaymentForm: { ...this.state.recordPaymentForm, amount: e.target.value } })} placeholder='Enter amount you are paying' />
										<small className='form-text text-muted'>{this.state.recordForTrip ? 'Enter the amount you are paying for this trip.' : 'Prefilled with unpaid trips only — already-paid trips are not included.'}</small>
									</div>
									<div className='form-group'>
										<label className='text-wrap'>Payment method</label>
										<select className='form-control' value={this.state.recordPaymentForm.payment_mode} onChange={(e) => this.setState({ recordPaymentForm: { ...this.state.recordPaymentForm, payment_mode: e.target.value } })}>
											{PAYMENT_METHODS.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
										</select>
									</div>
									<div className='form-group'>
										<label className='text-wrap'>Receipt / Reference no.</label>
										<input type='text' className='form-control' value={this.state.recordPaymentForm.receipt_no} onChange={(e) => this.setState({ recordPaymentForm: { ...this.state.recordPaymentForm, receipt_no: e.target.value } })} placeholder='Optional' />
									</div>
									<div className='form-group'>
										<label className='text-wrap'>Remarks</label>
										<input type='text' className='form-control' value={this.state.recordPaymentForm.remarks} onChange={(e) => this.setState({ recordPaymentForm: { ...this.state.recordPaymentForm, remarks: e.target.value } })} placeholder='Optional' />
									</div>
								</div>
								<div className='modal-footer flex-shrink-0'>
									<button type='button' className='btn btn-secondary' onClick={this.closeRecordPayment}>Cancel</button>
									<button type='button' className='btn btn-primary' onClick={this.recordPaymentSubmit} disabled={!!this.state.recording || !this.state.recordPaymentForm.amount}>Record payment</button>
								</div>
							</div>
						</div>
					</div>
				)}

				{/* View Members modal (Group Tours / Shared Rentals only) */}
				{this.state.membersModal && (
					<div className='modal fade show d-block' style={{ background: 'rgba(0,0,0,0.5)' }} tabIndex={-1}>
						<div className='modal-dialog modal-dialog-centered modal-lg'>
							<div className='modal-content'>
								<div className='modal-header'>
									<h5 className='modal-title'>{this.state.membersModal.title} — Members</h5>
									<button type='button' className='close' onClick={this.closeMembersModal}><span>&times;</span></button>
								</div>
								<div className='modal-body p-0'>
									{this.state.loadingMembers ? (
										<div className='p-3 text-muted'>Loading…</div>
									) : (
										<div className='table-responsive'>
											<table className='table table-sm table-bordered mb-0'>
												<thead>
													<tr>
														<th>Name</th>
														<th>Email</th>
														<th>Phone</th>
														<th>No. of people</th>
														<th>Status</th>
													</tr>
												</thead>
												<tbody>
													{(this.state.membersModal.members || []).map((m) => (
														<tr key={m.idx || m.email}>
															<td>{m.name || '—'}</td>
															<td>{m.email || '—'}</td>
															<td>{m.phone || '—'}</td>
															<td>{m.number_of_people != null ? m.number_of_people : 1}</td>
															<td>{m.status || '—'}</td>
														</tr>
													))}
												</tbody>
											</table>
											{(!this.state.membersModal.members || this.state.membersModal.members.length === 0) && !this.state.loadingMembers && <div className='p-3 text-muted'>No members.</div>}
										</div>
									)}
								</div>
								<div className='modal-footer'>
									<button type='button' className='btn btn-secondary' onClick={this.closeMembersModal}>Close</button>
								</div>
							</div>
						</div>
					</div>
				)}
			</React.Fragment>
        );
    }
}

export default SummaryList;